import { getAvailableMessengers } from 'widget/api/messenger';
import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';

const state = {
  records: [],
  uiFlags: {
    isError: false,
    hasFetched: false,
  },
};

export const getters = {
  getHasFetched: $state => $state.uiFlags.hasFetched,
  availableMessengers: $state => $state.records,
};

export const actions = {
  fetchAvailableMessengers: async ({ commit }, websiteToken) => {
    try {
      const { data } = await getAvailableMessengers(websiteToken);
      const { payload = [] } = data;
      commit('setMessengers', payload);
      commit('setError', false);
      commit('setHasFetched', true);
    } catch (error) {
      commit('setError', true);
      commit('setHasFetched', true);
    }
  },
  updatePresence: async ({ commit }, data) => {
    commit('updatePresence', data);
  },
};

export const mutations = {
  setMessengers($state, data) {
    $state.records = data;
  },
  updatePresence: MutationHelpers.updatePresence,
  setError($state, value) {
    $state.uiFlags.isError = value;
  },
  setHasFetched($state, value) {
    $state.uiFlags.hasFetched = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
